<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.dataInicial.$error ? false : null"
                    invalid-feedback="Data Inicial é obrigatória"
                >
                    <label>Data Inicial</label>
                    <date-picker
                        v-model="dataInicial"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.dataInicial.$touch()"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.dataFinal.$error ? false : null"
                    invalid-feedback="Data Final é obrigatória"
                >
                    <label>Data Final</label>
                    <date-picker
                        v-model="dataFinal"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.dataFinal.$touch()"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="3"
                        @input="$v.descricao.$touch()"
                        :state="$v.descricao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A descrição é obrigatória
                    </b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" v-if="this.tipoOperacao == 'i'">
                <b-checkbox
                    v-model="status"
                    @change="selecionarOpcaoConcluida($event)"
                >
                    Concluída
                </b-checkbox>
            </b-col>
        </b-row>
        <div class="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                :disabled="desabilitarBtnSalvar"
                >
                Salvar
            </b-button
            >
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ManutencaoServicos from './ManutencoesContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        tipoOperacao: {
            type: String,
            default: () => ''
        },

        showModal: {
            type: Boolean,
            default: () => false
        },
        idManutencaoContrato: {
            type: String,
            default: () => ''
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],            
            descricao: '',
            dataInicial: new Date(),
            dataFinal: new Date(),
            status: 0,
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            this.erros = []
            this.descricao = ''
            this.dataInicial = new Date()
            this.dataFinal = new Date()
            this.status = 0
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.tipoOperacao == 'a') {
                this.obterManutencao()
            }
        },

        obterManutencao() {
            this.$store.dispatch('addRequest')
            ManutencaoServicos.obterManutencao(
                this.contrato.idContrato,
                this.idManutencaoContrato
            ).then(response => {
                if (response) {
                    if (response.success) {
                        console.log(response.data)
                        this.descricao = response.data.descricao
                        this.dataInicial = this.$moment(
                            response.data.dataInicio
                        ).format('DD/MM/YYYY')
                        this.dataFinal = this.$moment(
                            response.data.dataFim
                        ).format('DD/MM/YYYY')
                        this.status = response.data.status
                    } else {
                        this.$toast.error(
                            'Erro ao obter a manutenção',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            let msg
            if (this.tipoOperacao == 'i') {
                msg = 'Confirma a inserção da Melhoria/Manutenção?'
            } else {
                msg = 'Confirma a atualização da Melhoria/Manutenção?'
            }

            this.$swal({
                title: 'Melhoria/Manutenção de Contrato',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let manutencaoDto = {
                contratoId: this.contrato.idContrato,
                dataInicio: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').toISOString()
                    : '',
                dataFim: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').toISOString()
                    : '',
                descricao: this.descricao,
                status: this.status,
            }

            let promisse
            if (this.tipoOperacao == 'i') {
                promisse = ManutencaoServicos.inserir(manutencaoDto)
            } else {
                manutencaoDto = { ...manutencaoDto, idManutencaoContrato: this.idManutencaoContrato }
                promisse = ManutencaoServicos.atualizar(this.contrato.idContrato, this.idManutencaoContrato, manutencaoDto)
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterManutencoesAtualizadas')
            this.fecharModal()
        },

        selecionarOpcaoConcluida(opcao) {
            if (opcao) {
                this.status = 1;
            } else {
                this.status = 0;
            }
        }
    },

    created() {
        this.preencherForm()
    },

    computed: {
        operacao() {
            switch (this.tipoOperacao) {
                case 'i':
                    return 'INSERIR'
                case 'a':
                    return 'ATUALIZAR'
                default:
                    break
            }
        },

        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {
        showModal() {
            this.mostrarModal = this.showModal
        }
    },

    validations: {
        descricao: {
            required
        },

        dataInicial: {
            required
        },

        dataFinal: {
            required
        },
        
        status: {

        }
    }
}
</script>
<style scoped>
    .modal-footer {
        justify-content: flex-end;
        padding: 1rem 0 0 0;
        margin: 0.5rem 0 0 0;
        border-top: 1px solid #c8ced3;
    }
</style>